import type { VpError as GQLItem } from './generated/graphql';
import { take } from './util';

export type VPError = {
  path: string;
  message: string;
};

export const fromGql = (error: GQLItem): VPError =>
  take(error, 'path', 'message') as VPError;

export const fromGqlCollection = (errors: GQLItem[] = []): VPError[] => errors?.map(fromGql) || [];
